import React from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
  return (
    <div className="contact-info">
      <h2>Contact Us</h2>
      <p>
        <strong>Phone:</strong>{' '}
        <a href="tel:+14352883693">(435) 288-3693</a>
      </p>
      <p>
        <strong>Email:</strong>{' '}
        <a href="mailto:burgerbarnbearlake@gmail.com">burgerbarnbearlake@gmail.com</a>
      </p>
      <p className="consent-notice">
        By calling or texting our number, you consent to receive communications from Burger Barn.
        See our <Link to="/privacy-policy">Privacy Policy</Link> for details.
      </p>
    </div>
  );
};

export default Contact;